export const selectEventDetails = (reduxState) => reduxState.eventDetails;
export const selectBusiness = (reduxState) => reduxState.eventDetails;
